import { render, staticRenderFns } from "./albaran.vue?vue&type=template&id=2c5d7160&"
import script from "./albaran.vue?vue&type=script&lang=js&"
export * from "./albaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports